import { Component } from '@angular/core';
import { SearchType } from '../../models/analys-resultat';

@Component({
    selector: 'app-specific-species-search',
    templateUrl: './specific-species-search.component.html',
    styleUrl: './specific-species-search.component.scss',
    standalone: false
})
export class SpecificSpeciesSearchComponent {
  protected searchType = SearchType.SPECIFIC;
}
